/**
 * Font family names used across the app (Tailwind, tenant styles, globals).
 * Single source of truth to avoid hardcoded strings.
 *
 * All ITC Avant Garde Gothic weights (300/400/500/700) are declared under one
 * family name so the browser selects the correct file via font-weight instead
 * of requiring weight-specific family aliases.
 */
export const AVANT_GARDE_FAMILY = 'AvantGarde'

/** Default app font family. Used as Tailwind default and tenant fallback. */
export const DEFAULT_FONT_FAMILY = AVANT_GARDE_FAMILY

/** Path to the default font file (for preload and @font-face src). */
export const DEFAULT_FONT_URL = '/fonts/itc-avant-garde-gothic_book.ttf'

/** System font stack used as fallback in body font-family. */
export const SYSTEM_FONT_STACK =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
